import React from "react";
import { Input } from "../../../components/Input";
import Divider from "@mui/material/Divider";
import classes from "./formStep1.module.scss";
import { useTranslation } from "react-i18next";
import Checkbox from "../../../components/Chechbox";

function FormStep1({
  handleChange,
  height,
  weight,
  job,
  bloodtype,
  severeـillnessـchek,
  severeـillness,
  smoke_chek,
  smoke,
  drink_alcohol_chek,
  drink_alcohol,
  addiction,
  addiction_text,
  medications_chek,
  medications,
  regular_exercise,
  regular_exercise_text,
  alergies,
  alergies_text,
  hereditary_illness,
  hereditary_illness_text,
}) {
  const { t } = useTranslation();

  return (
    <div>
      <div className={classes.flexContainer}>
        <Input
          //   error={!!errorMessage.height}
          //   helperText={errorMessage.height && errorMessage.height}
          name="height"
          label={t("pages.protectedPages.medicalHistory.User.height")}
          onChange={handleChange}
          required
          value={height}
        />

        <Input
          name="weight"
          label={t("pages.protectedPages.medicalHistory.User.weight")}
          onChange={handleChange}
          required
          value={weight}
        />

        <Input
          name="job"
          label={t("pages.protectedPages.medicalHistory.User.job")}
          onChange={handleChange}
          required
          value={job}
        />

        <Input
          name="bloodtype"
          label={t("pages.protectedPages.medicalHistory.User.bloodType")}
          onChange={handleChange}
          required
          value={bloodtype}
        />
      </div>
      <Divider />
      <div style={{ marginTop: 20 }}>
        <label>{t("pages.protectedPages.medicalHistory.User.routine")}</label>
        <div className={classes.innerContainer}>
          <Checkbox
            name="severeـillnessـchek"
            checked={severeـillnessـchek}
            handleChange={handleChange}
            labelText="yes"
            value={severeـillnessـchek}
          />
          <Input
            name="severeـillness"
            label={t("pages.protectedPages.medicalHistory.User.routineYes")}
            onChange={handleChange}
            required
            // fullWidth
            value={severeـillness}
          />
        </div>
      </div>
      <div>
        <label>{t("pages.protectedPages.medicalHistory.User.smoke")}</label>

        <div className={classes.innerContainer}>
          <Checkbox
            name="smoke_chek"
            checked={smoke_chek}
            handleChange={handleChange}
            labelText="yes"
            value={smoke_chek}
          />
          <Input
            name="smoke"
            label={t("pages.protectedPages.medicalHistory.User.smokeYes")}
            onChange={handleChange}
            required
            value={smoke}
          />
        </div>
      </div>
      <div>
        <label>{t("pages.protectedPages.medicalHistory.User.drink")}</label>
        <div className={classes.innerContainer}>
          <Checkbox
            name="drink_alcohol_chek"
            checked={drink_alcohol_chek}
            handleChange={handleChange}
            labelText="yes"
            value={drink_alcohol_chek}
          />
          <Input
            name="drink_alcohol"
            label={t("pages.protectedPages.medicalHistory.User.drinkYes")}
            onChange={handleChange}
            required
            value={drink_alcohol}
          />
        </div>
      </div>
      <div>
        <label>{t("pages.protectedPages.medicalHistory.User.addicted")}</label>

        <div className={classes.innerContainer}>
          <Checkbox
            name="addiction"
            checked={addiction}
            handleChange={handleChange}
            labelText="yes"
            value={addiction}
          />
          <Input
            name="addiction_text"
            label={t("pages.protectedPages.medicalHistory.User.addictedYes")}
            onChange={handleChange}
            required
            value={addiction_text}
          />
        </div>
      </div>
      <div>
        <label>
          {t("pages.protectedPages.medicalHistory.User.medications")}
        </label>
        {/* <FormControlLabel
              className="CheckboxSbm"
              control={
                <Controller
                  control={control}
                  inputRef={register}
                  name="medications_chek"
                  render={({ field: { onChange, value } }) => (
                    <Checkbox
                      onChange={(e) => onChange(e.target.checked)}
                      checked={value}
                    />
                  )}
                />
              }
              label={t("pages.protectedPages.medicalHistory.yes")}
            /> */}
        <div className={classes.innerContainer}>
          <Checkbox
            name="medications_chek"
            checked={medications_chek}
            handleChange={handleChange}
            labelText="yes"
            value={medications_chek}
          />
          <Input
            name="medications"
            label={t("pages.protectedPages.medicalHistory.User.medicationsYes")}
            onChange={handleChange}
            required
            value={medications}
          />
        </div>
      </div>
      <div>
        <label>{t("pages.protectedPages.medicalHistory.User.exercise")}</label>
        {/* <FormControlLabel
              className="CheckboxSbm"
              control={
                <Controller
                  control={control}
                  inputRef={register}
                  name="regular_exercise"
                  render={({ field: { onChange, value } }) => (
                    <Checkbox
                      onChange={(e) => onChange(e.target.checked)}
                      checked={value}
                    />
                  )}
                />
              }
              label={t("pages.protectedPages.medicalHistory.yes")}
            /> */}
        <div className={classes.innerContainer}>
          <Checkbox
            name="regular_exercise"
            checked={regular_exercise}
            handleChange={handleChange}
            labelText="yes"
            value={regular_exercise}
          />
          <Input
            name="regular_exercise_text"
            label={t("pages.protectedPages.medicalHistory.User.exerciseYes")}
            onChange={handleChange}
            required
            value={regular_exercise_text}
          />
        </div>
      </div>
      <div>
        <label>{t("pages.protectedPages.medicalHistory.User.allergies")}</label>
        {/* <FormControlLabel
              className="CheckboxSbm"
              control={
                <Controller
                  control={control}
                  inputRef={register}
                  name="alergies"
                  render={({ field: { onChange, value } }) => (
                    <Checkbox
                      onChange={(e) => onChange(e.target.checked)}
                      checked={value}
                    />
                  )}
                />
              }
              label={t("pages.protectedPages.medicalHistory.yes")}
            /> */}
        <div className={classes.innerContainer}>
          <Checkbox
            name="alergies"
            checked={alergies}
            handleChange={handleChange}
            labelText="yes"
            value={alergies}
          />
          <Input
            name="alergies_text"
            label={t("pages.protectedPages.medicalHistory.User.allergiesYes")}
            onChange={handleChange}
            required
            value={alergies_text}
          />
        </div>
      </div>
      <div>
        <label>
          {t("pages.protectedPages.medicalHistory.User.particular")}
        </label>
        <div className={classes.innerContainer}>
          <Checkbox
            name="hereditary_illness"
            checked={hereditary_illness}
            handleChange={handleChange}
            labelText="yes"
            value={hereditary_illness}
          />
          <Input
            name="hereditary_illness_text"
            label={t("pages.protectedPages.medicalHistory.User.particularYes")}
            onChange={handleChange}
            required
            value={hereditary_illness_text}
          />
        </div>
      </div>
    </div>
  );
}

export default FormStep1;
